import {MessageInput, MessageToSend, useChannelActionContext} from "stream-chat-react";
import log from "loglevel";

const DispatchMessageInput: React.FC = () => {
  const {sendMessage} = useChannelActionContext();

  const overrideSubmitHandler = (message: MessageToSend) => {
    sendMessage(message, {silent: true}).catch((reason) => {
      log.error("Error sending message: ", reason);
    });
  };

  return <MessageInput grow overrideSubmitHandler={overrideSubmitHandler} />;
};

export default DispatchMessageInput;
